<template>
    <PDA_Handover-components>
        <div class="p-2 m-3">

            <div id="listloader" v-if="Loader">
                <div class="listloader"></div>
            </div>

            <!-- Allocate PDA -->
            <div>
                <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                    <b-row>
                        <b-col md="4">
                            <b-from-group>
                                <b-row>
                                    <b-col md="3" class="pr-0">
                                        <strong>PDA Name</strong>
                                    </b-col>
                                    <b-col md="9" class="pl-0">
                                        <!-- <b-form-input v-model="customer.pdaid" placeholder="Enter PDA ID" name="PDA ID" v-validate="'required'"
                                        :class="{input: true,'is-invalid': errors.has('form-1.PDA ID'),
                                        }"></b-form-input> -->
                                        <v-select :options="pdaidList"  v-model="customer.pdaid" placeholder="Select PDA Name" name="PDA Name" v-validate="'required'" 
                                        :class="{input: true,'is-invalid': errors.has('form-1.PDA Name'),}" @change="selectUserName(customer.pdaid)"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('PDA Name')"></i>
                                            </span>
                                            <span style="width:240px" v-show="errors.has('form-1.PDA Name')" class="help text-danger">{{ errors.first("form-1.PDA Name") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-from-group>
                        </b-col>

                        <b-col md="4">
                            <b-from-group>
                                <b-row>
                                    <b-col md="3" class="pr-0">
                                        <strong>User Name</strong>
                                    </b-col>
                                    <b-col md="9">
                                        <!-- <v-select v-model="customer.username" :options="userList" placeholder="-- Select User --" name="User Name" v-validate="'required'"
                                        :class="{input: true,'is-invalid': errors.has('form-1.User Name'),fie
                                        }"></v-select> -->
                                        <b-form-input disabled v-model.trim="customer.username" placeholder="Enter Username" name="User Name" v-validate="'required'"
                                        :class="{input: true,'is-invalid': errors.has('form-1.User Name'),
                                        }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('User Name')"></i>
                                            </span>
                                            <span style="width:240px" v-show="errors.has('form-1.User Name')" class="help text-danger">{{ errors.first("form-1.User Name") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-from-group>
                        </b-col>

                        <b-col md="4">
                            <b-from-group>
                                <b-row>
                                    <b-col md="3" style="max-width: max-content">
                                        <strong>Condition</strong>
                                    </b-col>
                                    <b-col md="9">
                                        <b-form-radio-group v-model="customer.conditon" class="mt-1" name="Condition" v-validate="'required'"
                                        :class="{input: true,'is-invalid': errors.has('form-1.Condition'),
                                        }">
                                            <b-form-radio value="Good"> Good </b-form-radio>
                                            <b-form-radio value="Defective"> Defective </b-form-radio>
                                        </b-form-radio-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('Condition')"></i>
                                            </span>
                                            <span style="width:240px" v-show="errors.has('form-1.Condition')" class="help text-danger">{{ errors.first("form-1.Condition") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-from-group>
                        </b-col>

                        <b-col md="4">
                            <b-from-group>
                                <b-row>
                                    <b-col md="3" class="pr-0" style="max-width: max-content">
                                        <strong>Comments</strong>
                                    </b-col>
                                    <b-col md="9">
                                        <b-form-input v-model.trim="customer.comment" placeholder="Enter Comments" name="Comments" v-validate="'required'"
                                        :class="{input: true,'is-invalid': errors.has('form-1.Comments'),
                                        }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('Comments')"></i>
                                            </span>
                                            <span style="width:240px" v-show="errors.has('form-1.Comments')" class="help text-danger">{{ errors.first("form-1.Comments") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-from-group>
                        </b-col>

                        <b-col md="4">
                            <b-from-group>
                                <b-row>
                                    <b-col md="4" class="pr-0">
                                        <strong>Upload Image</strong>
                                    </b-col>
                                    <b-col md="8" class="pl-0">
                                        <b-form-file type="file"
                                        v-model="customer.image_file"
                                        :state="Boolean(image_file)"
                                        placeholder="Upload Photo" 
                                        @change="selectFile($event)"
                                        accept="image/*" plain></b-form-file>
                                    </b-col>
                                </b-row>
                            </b-from-group>
                        </b-col>

                        <b-col class="4" v-if="customer.conditon=='Defective'">
                            <b-from-group>
                                <b-row>
                                    <b-col md="3" class="pr-0">
                                        <strong>Issue</strong>
                                    </b-col>
                                    <b-col md="9" class="pl-0">
                                        <v-select v-model="customer.issue" :options="issueList" placeholder="-- Select Issue --" name="Issues" v-validate="'required'"
                                        :class="{input: true,'is-invalid': errors.has('form-1.Issues'),
                                        }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('Issues')"></i>
                                            </span>
                                            <span style="width:240px" v-show="errors.has('form-1.Issues')" class="help text-danger">{{ errors.first("form-1.Issues") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-from-group>
                        </b-col>

                        <b-col md="4" v-if="customer.conditon=='Defective'">
                            <b-from-group>
                                <b-row>
                                    <b-col md="3">
                                        <strong>Severity</strong>
                                    </b-col>
                                    <b-col md="9">
                                        <b-form-radio-group v-model="customer.severity" class="mt-1" name="Severity" v-validate="'required'"
                                        :class="{input: true,'is-invalid': errors.has('form-1.Severity'),
                                        }">
                                            <b-form-radio value="Low"> Low </b-form-radio>
                                            <b-form-radio value="Medium"> Medium </b-form-radio>
                                            <b-form-radio value="High"> High </b-form-radio>
                                        </b-form-radio-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('Severity')"></i>
                                            </span>
                                            <span style="width:240px" v-show="errors.has('form-1.Severity')" class="help text-danger">{{ errors.first("form-1.Severity") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-from-group>
                        </b-col>
                        
                        <b-col md="4">
                            <b-button variant="primary" type="submit" :disabled="isReadOnly">Save</b-button>&nbsp;&nbsp;
                            <b-button variant="danger" @click="clear()">Clear</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </div>

            <!-- Table -->
            <br><br>
            <b-row>
                <b-col md="6">
                    <span style="font-size: 15px;">Handover PDA (today)</span>
                </b-col>
                <b-col md="6">
                    <div class="float-right">
                        <b>Total Records : <span style="color: red;">{{totalRows}}</span></b>
                    </div>
                </b-col>
            </b-row>

            <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection" :outlined="outlined" :busy="isBusy">
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>  
                <template slot="user_name" slot-scope="row">
                    <div>
                        {{ row.item.userfirstname + ' ' +  row.item.userlastname}}
                    </div>
                </template>
            </b-table>

            <!-- paginatio -->
            <b-col md="12" class="my-1" >
                <paginate 
                v-model="pageNum"
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
              </paginate>
            </b-col>  
        </div>
    </PDA_Handover-components>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
const axios = require('axios')

export default {
    name:'PDA_Handover',

    data() {
        return {
            Loader:false,
            // List 
            pdaidList:[],
            issueList:[],
            customer:{},
            selected_imagefile : '',
            selectedfile_type : '',
            uploadedphoto :'',

             // Table
            isBusy:false,
            totalRows:0,
            items:[],
            fields:[
                {key:'pda_id', label:'PDA ID',thClass: 'text-center'},
                {key:'pda_name', label:'PDA Name',thClass: 'text-center'},
                {key:'user_name', label:'User Name',thClass: 'text-center'},
                {key:'allocated_date', label:'Date',thClass: 'text-center'},
                {key:'allocated_time', label:'PDA Allocated Time',thClass: 'text-center'},
                {key:'hanover_time', label:'PDA Handover Time',thClass: 'text-center'},
                {key:'pda_condition', label:'Condition',thClass: 'text-center'},
                {key:'pda_severity', label:'Severity',thClass: 'text-center'},
                {key:'issue_name', label:'Issues',thClass: 'text-center'},
                {key:'shift', label:'Shift',thClass: 'text-center'},
                {key:'total_time', label:'Total Time',thClass: 'text-center'},
                {key:'session', label:'Active Status',thClass: 'text-center'},
            ],
            currentPage:1,
            perPage:20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();
        this.handoverpdaList();
        this.handoverissueList();
        this.handoverPDAList(this.pageNum);
    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='PDA Configuration' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='PDA Configuration' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        
        handoverpdaList(){
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.pdaidList=[];
            var List = [];
            const Obj={
                hub_id: userInfo.hub_id
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/handoverPDAWithOpenSession`,Obj)
            .then(result=>{
                this.Loader=false;
                if (result.body.returnmsg==='Successful') {
                    List = result.body.returnvalue;
                    List.forEach(element => {
                        let PDA = {
                            key : element.pda_id,
                            pda_allocated_time : element.pda_allocated_time,
                            userName : element.userName,
                            label : element.pda_name,
                        }
                        this.pdaidList.push(PDA)
                    });

                } else {
                    this.pdaidList=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        selectUserName(value){
            if (value) {
                this.customer.username = value.userName;
            }
            else{
                this.customer.username = "";
            }
        },

        handoverissueList(){
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.issueList=[];
            var List = [];
            const Obj={
                status: 'handover'
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addPDAIssueList`,Obj)
            .then(result=>{
                this.Loader=false;
                if (result.body.returnmsg==='Successful') {
                    List = result.body.returnvalue;
                    List.forEach(element => {
                        let PDA = {
                            key : element.issue_id,
                            label : element.issue_name,
                        }
                        this.issueList.push(PDA)
                    });

                } else {
                    this.issueList=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        selectFile(event){
      
            this.selected_imagefile= event.target.files[0];
            this.selectedfile_type=this.selected_imagefile.type;
            this.uploadphoto(this.selected_imagefile);

        },

        uploadphoto : function () {
            this.Loader = true;
            var userData = localStorage.getItem('userData');
            var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selected_imagefile)
            this.progress=0;
            let config = {
                header : {
                    'Content-Type' : 'multipart/form-data'
                }
            }

            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadFileToS3`,data).then(response => {
                this.Loader = false;
                if (response.data.result=="success") {
                    this.$fire({
                        text:"File Uploaded.Please Submit",
                        type: "success",
                        timer: 300000
                    })
                    this.uploadedphoto=response.data.file_url;
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                this.errors.push(e)
            })
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.handOverallocatePDA();
                }
            });
        },

        handOverallocatePDA(){
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj ={

                pda_id : this.customer.pdaid.key,
                sysusermasterid : `${userInfo.sysusermasterid}`,
                pda_allocated_time : `${this.customer.pdaid.pda_allocated_time}`,
                pda_condition : `${this.customer.conditon}`,
                handover_comment : `${this.customer.comment}`,
                handover_image :  this.uploadedphoto,
                pda_issue : this.customer.conditon == 'Defective' ? this.customer.issue.key:null,
                pda_severity : `${this.customer.conditon == 'Defective' ?this.customer.severity:null}`,
                createdby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`
            }
            
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/handOverAllocatedPDA`,Obj)
            .then(result=>{
                this.Loader = false;
                if (result.body.returnmsg==='Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                    
                    this.errors={};
                    this.errors.clear('form-1');
                    this.customer={};
                    this.handoverpdaList();
                    this.handoverissueList();
                    this.handoverPDAList(this.pageNum);
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.handoverPDAList(pageNum);
        },

        handoverPDAList(page_Num){
            this.isBusy=true;
            this.items=[];
            this.totalRows=0;

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={
                status:'handover',
                page_no:`${page_Num}`,
                hub_id:userInfo.hub_id,
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/allocatePDAToUserList`,Obj)
            .then(result=>{
                this.isBusy=false;
                if (result.body.returnmsg==='Successful') {
                    this.items = result.body.returnvalue;
                    this.totalRows =  result.body.totalrecord;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.items=[];
                    this.totalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clear(){
            this.errors={};
            this.errors.clear('form-1');
            this.customer={};
            this.handoverpdaList();
            this.handoverissueList();
            this.handoverPDAList(this.pageNum);
        },

    },
}
</script>